/**
 * Header Navigation – Hover Dropdowns
 * Smooth height animation on mouseenter/mouseleave,
 * similar to gentlemonster.com navigation pattern.
 * Dropdown overlay is appended to <body> so backdrop-filter
 * works independently from the header's own blur.
 */
(function () {
  const items = document.querySelectorAll('[js-nav-dropdown]');
  if (!items.length) return;

  const header = document.querySelector('[js-header]');
  let closeTimer = null;
  let activeItem = null;

  // Create a single shared overlay element on <body>
  const overlay = document.createElement('div');
  overlay.className = 'site-header__dropdown-overlay';
  overlay.style.cssText = 'position:fixed;left:0;width:100vw;overflow:hidden;height:0;transition:height .3s ease-in-out;z-index:99;pointer-events:none;';
  document.body.appendChild(overlay);

  // Create content containers for each nav item inside the overlay
  const contentMap = new Map();
  items.forEach(item => {
    const original = item.querySelector('[js-nav-dropdown-content]');
    if (!original) return;

    // Move the UL from the original dropdown into a new container
    const ul = original.querySelector('ul');
    if (!ul) return;

    const container = document.createElement('div');
    container.style.cssText = 'display:none;';
    container.appendChild(ul.cloneNode(true));
    overlay.appendChild(container);
    contentMap.set(item, container);

    // Hide original dropdown
    original.style.display = 'none';
  });

  // Use --header-height CSS variable for stable positioning (nav row +
  // announcement bar, whichever is currently visible). getBoundingClientRect()
  // shifts during the header's hide/show CSS transition, but this var is
  // always the true height. --nav-bar-height alone omits the announcement
  // bar and undershoots whenever it's visible.
  function positionOverlay() {
    const headerHeight = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height')
    );
    overlay.style.top = headerHeight + 'px';
  }

  positionOverlay();
  window.addEventListener('resize', positionOverlay);

  // Close dropdown on scroll
  window.addEventListener('scroll', () => {
    if (activeItem) {
      clearTimeout(closeTimer);
      closeDropdown();
    }
  });

  function openDropdown(item) {
    clearTimeout(closeTimer);

    // Hide all containers, show the active one
    contentMap.forEach((container) => {
      container.style.display = 'none';
    });

    const container = contentMap.get(item);
    if (!container) return;

    const itemRect = item.getBoundingClientRect();
    container.style.display = 'block';
    container.style.paddingLeft = itemRect.left + 'px';

    activeItem = item;
    overlay.style.pointerEvents = 'auto';
    overlay.style.borderTop = '1px solid rgba(0, 0, 0, 0.1)';
    overlay.style.borderBottom = '1px solid rgba(0, 0, 0, 0.1)';
    overlay.style.height = container.scrollHeight + 'px';
  }

  function closeDropdown() {
    overlay.style.height = '0px';
    overlay.style.pointerEvents = 'none';
    activeItem = null;
  }

  // Remove borders only after the height transition finishes
  overlay.addEventListener('transitionend', (e) => {
    if (e.propertyName === 'height' && !activeItem) {
      overlay.style.borderTop = '0';
      overlay.style.borderBottom = '0';
    }
  });

  function scheduleClose() {
    closeTimer = setTimeout(closeDropdown, 200);
  }

  items.forEach(item => {
    item.addEventListener('mouseenter', () => openDropdown(item));
    item.addEventListener('mouseleave', scheduleClose);
  });

  // Keep open when hovering the overlay itself
  overlay.addEventListener('mouseenter', () => {
    clearTimeout(closeTimer);
  });
  overlay.addEventListener('mouseleave', scheduleClose);

  // Also keep open when hovering anywhere on the header (bridges the gap)
  header.addEventListener('mouseenter', () => {
    if (activeItem) clearTimeout(closeTimer);
  });
})();
